import * as React from 'react';
import { SVGProps } from 'react';

const IconTechResponseSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
    <path d="M3 6H1.503c0-.198.018-.396.042-.588l-1.266-.99a.296.296 0 0 1-.072-.384l1.2-2.076a.293.293 0 0 1 .366-.132l1.494.6a4.61 4.61 0 0 1 1.014-.588l.228-1.59A.293.293 0 0 1 4.803 0h2.4c.15 0 .276.108.294.252l.228 1.59c.366.15.702.348 1.014.588l1.494-.6a.302.302 0 0 1 .366.132l1.2 2.076a.303.303 0 0 1-.072.384l-1.266.99c.024.192.042.384.042.588H9a3 3 0 0 0-6 0ZM7 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM2 7h1v2.134a1 1 0 1 1-1 0V7ZM9.5 11a1 1 0 0 0 .5-1.866V7H9v2.134A1 1 0 0 0 9.5 11Z" />
  </svg>
);
export default IconTechResponseSizeXs;
